export default __webpack_public_path__ + "static/media/Statistic_HE_2013-2014.5ed47b4a.pdf";